import { createCustomToggle, updateFooterLogos, customSignup } from './helpers';

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  createCustomToggle();
  updateFooterLogos();
  customSignup();
});
